import styled from 'styled-components';

import { WHITE, TOOLTIP_SHADOW_COLOR } from '../../../utils/colors';

export const Tooltip = styled.div`
  position: absolute;
  transform: ${({ top, left }) => `translate(${left}px, ${top}px)`};
  background-color: ${WHITE};
  padding: 12px 15px;
  box-shadow: 0 1px 2px ${TOOLTIP_SHADOW_COLOR};
  font-family: sans-serif;
  font-size: 13px;
  line-height: 1.1em;
`;
